import { useEffect, useState } from "react";
import { QuotesService } from "../../../api";
import { Quote } from "../types/Quote";

export const useQuote = (requestId?: string) => {
  const [quote, setQuote] = useState<Quote | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!requestId) return;

    setLoading(true);

    QuotesService.getQuoteQuotesServiceRequestIdGet(Number(requestId))
      .then((res) => {
        // ✅ normalize ONCE here
        setQuote(res?.quote ?? null);
      })
      .catch((err) => {
        console.error("Failed to fetch quote", err);
        setQuote(null);
      })
      .finally(() => setLoading(false));
  }, [requestId]);

  return { quote, loading };
};